module.exports = __webpack_public_path__ + "media/components/t-shirt-comp/static/t-shirt-icon-77d24769ad76da10d8622462786054fc.png";